module.exports = __webpack_public_path__ + "static/desc.0014aa45.png";